import { useMemo } from 'react';
import { toTitleFromFileName } from './aiUtils';

export default function AiImageCard({ src, fileName, className = '' }) {
  const title = useMemo(() => toTitleFromFileName(fileName, src), [fileName, src]);

  return (
    <div className={`ai-card ai-image-card ${className}`.trim()}>
      <div className="ai-image-viewport">
        <img src={src} alt={title} />
      </div>
      <div className="ai-caption">{title}</div>
    </div>
  );
}

